export default "__VITE_ASSET__KEHKV4rK__"